const data = {
  colors: require("./colors.json"),
  text: require("./title.json"),
  positions: require("./positions.json"),
  camera: require("./camera.json"),
};

export default data;
